var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7722 14.0008L24.2369 9.27389C24.2434 9.24156 24.2499 9.20922 24.2563 9.17042V2.98855C24.2499 2.61997 23.9589 2.32251 23.5903 2.30958H20.4994C20.1437 2.30958 19.8527 2.62643 19.8527 2.98855V5.54924L15.4233 1.77287C15.184 1.56594 14.8283 1.56594 14.5826 1.77287L0.233689 13.9944C-0.0443657 14.2207 -0.0766977 14.6281 0.149626 14.9061C0.37595 15.1842 0.783333 15.2165 1.06139 14.9902C1.06785 14.9837 1.06785 14.9837 1.07432 14.9772L15.0029 3.11788L19.9885 7.3663L22.9695 9.90113L28.938 14.9837C29.2096 15.2165 29.617 15.1842 29.8498 14.9126C30.0761 14.641 30.0438 14.2336 29.7722 14.0008ZM22.9566 8.18107L21.146 6.655V3.60933H22.9566V8.18107Z",
    fill: "#8f65da"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.9205 15.3072L25.1034 13.7553L15.4232 5.48478C15.184 5.27786 14.8283 5.27786 14.5826 5.48478L4.90239 13.7553L3.08534 15.3072C2.81375 15.54 2.78142 15.9474 3.01421 16.219C3.24053 16.4906 3.64145 16.5229 3.90657 16.2966L3.91303 16.2901L4.72133 15.5918V27.7162C4.7278 28.0784 5.02525 28.3758 5.38737 28.3823H24.612C24.9741 28.3758 25.2715 28.0848 25.278 27.7162V15.5918L26.0863 16.2901C26.2027 16.3871 26.345 16.4453 26.5002 16.4453C26.6877 16.4453 26.8687 16.3613 26.9916 16.219C27.2309 15.9409 27.1921 15.5336 26.9205 15.3072ZM17.5895 27.0825H12.4163V20.0988H17.5895V27.0825ZM18.8827 27.0825V19.4716C18.8827 19.1159 18.6176 18.8056 18.262 18.8056H11.7438C11.3882 18.8056 11.1231 19.1159 11.1231 19.4716V27.0825H6.01461V14.486L15.0029 6.82979L23.9912 14.486V27.0825H18.8827Z",
    fill: "#8f65da"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.84d2b418e38a9f217a4419a81b296573.svg";
export { ForwardRef as ReactComponent };